import React, { Component, PropTypes } from 'react';
import _ from 'lodash';

import NavBar from './NavBar';
import NavLink from './NavLink';
import { hasConfirmedSubmission, spaceToUnderscore } from '../helpers/helpers';
import * as ROLE from "../constants/roles";
import HighestDropboxRoleSelector from "../selectors/HighestDropboxRoleSelector";

class SubmissionActionLinks extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { auth, assignment, memberships, roles_self, submission } = this.props,
            { dropbox } = assignment
        ;

        return dropbox
        ? (
            <NavBar
                className="submission-action-links navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
            >
                <NavLink
                    to={"/?expand=" + dropbox.id}
                    className="btn btn-outline-primary btn-md"
                    side="left"
                    display={
                        dropbox.show_index > 0  ||
                        (   _.includes(
                                [ ROLE.ADMIN, ROLE.INSTRUCTOR ],
                                HighestDropboxRoleSelector({ roles: roles_self })
                            )
                        )
                    }
                    key="course"
                >
                    Exit To Course <i className={"fa fa-chevron-circle-left"}/>
                </NavLink>
                <NavLink
                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/group`}
                    className="btn btn-success btn-md"
                    side="right"
                    display={
                        assignment.group_submission &&
                        _.size(memberships) > 0 &&
                        submission.id !== "-1" &&
                        hasConfirmedSubmission(auth.id, submission, memberships)
                    }
                    key="my_group"
                >
                    My Group <i className="fa fa-users" aria-hidden="true"/>
                </NavLink>
            </NavBar>
        ) : (
            null
        );
    }
}

SubmissionActionLinks.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    memberships: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    submission: PropTypes.object.isRequired
};

export default SubmissionActionLinks;


/** WEBPACK FOOTER **
 ** ./src/components/SubmissionActionLinks.js
 **/